import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class DashboardProfile extends React.Component{

    renderAceScore = (tags) => {
        if(tags){
            switch(true){
                case tags.includes('7905'):
                    return '0';
                case tags.includes('7907'):
                    return '1';
                case tags.includes('7909'):
                    return '2';
                case tags.includes('7911'):
                    return '3';
                case tags.includes('7913'):
                    return '4';
                case tags.includes('7915'):
                    return '5';
                case tags.includes('7917'):
                    return '6';
                case tags.includes('7919'):
                    return '7';
                case tags.includes('7921'):
                    return '8';
                case tags.includes('7923'):
                    return '9';
                case tags.includes('7925'):
                    return '10';
                default:
                    return <span>&mdash;</span>;
            }
        }
        return <span>&mdash;</span>;
    };

    renderAvatar = (tags) => {
        if(tags){
            switch(true){
                case tags.includes('11590'):
                    return 'Mentor';
                case tags.includes('11592'):
                    return 'Alchemist';
                case tags.includes('11594'):
                    return 'Goddess Avenger';
                case tags.includes('11596'):
                    return 'Mystic';
                case tags.includes('11598'):
                    return 'Hero Guide';
                default:
                    return <span>&mdash;</span>;
            }
        }
        return <span>&mdash;</span>;
    };

    renderMembershipLevel = (user) => {
        if(user){
            switch(true){
                case user.violetMember:
                    return <div className="membership-level"><img alt="Violet flame member" src="images/violetFlame-icon.svg" />Violet flame member</div>;
                case user.midasMember:
                    return <div className="membership-level"><img alt="Midas member" src="images/midasRecovery-icon.svg" />Midas member</div>;
                case user.circleMember:
                    return <div className="membership-level"><img alt="Circle member" src="images/circle-icon.svg" />Circle member</div>;
                default:
                    return <div className="membership-level"><img alt="Free member" src="images/user-icon.svg" />Free member</div>;
            }
        }
        return <div className="membership-level"><img alt="Free member" src="images/user-icon.svg" />Free member</div>;
    };

    renderBirthday = (birthday) => {
        if(birthday){
            const birthdayMoment = moment(birthday, "YYYYMMDDTHH:mm:ss");
            const age = moment().diff(birthdayMoment, 'years', true);
            return `${birthdayMoment.format("Do MMM YYYY")} (${Math.floor(age)} years old)`;
        }
        return <span>&mdash;</span>;
    };

    renderAddress = (userAddress) => {
        const filteredAddress = userAddress.filter(field => {
            return (typeof field !== 'undefined');
        });

        if(filteredAddress.length){
            return filteredAddress.join(', ');
        }
        return <span>&mdash;</span>;
    };

    render() {
        const user = this.props.user;
        // console.log(user);
        return (
                <div className="profile-panel">
                    <div>
                        <img className="user-avatar" alt="user-avatar" src={user._NKPhoto && user._NKPhoto !== "null" ? user._NKPhoto : "images/user-icon.svg"} />
                        <div className="user-name">{user.FirstName} {user.LastName}</div>
                        <div className="user-email">{user.Username === '' ? '' : user.Username}</div>

                        <div className="key-stats">
                            <div className="stat">
                                <span>Life code</span> {user._Lifecode || <span>&mdash;</span>}
                            </div>
                            <div className="pipe" />
                            <div className="stat">
                                <span>Avatar</span> {this.renderAvatar(user.tags)}
                            </div>
                            <div className="pipe" />
                            <div className="stat">
                                <span>ACE score</span> {this.renderAceScore(user.tags)}
                            </div>
                        </div>
                        {this.renderMembershipLevel(user)}
                    </div>
                    <div>
                        <h6>Personal details</h6>
                        <table className="table profile-table">
                            <tbody>
                                <tr>
                                    <td><i className="material-icons">email</i></td>
                                    <td><a href={`mailto:${user.Email}`}>{user.Email}</a></td>
                                </tr>
                                <tr>
                                    <td><i className="material-icons">phone</i></td>
                                    <td>{user.Phone1 || <span>&mdash;</span>}</td>
                                </tr>
                                <tr>
                                    <td><i className="material-icons">phone</i></td>
                                    <td>{user.Phone2 || <span>&mdash;</span>}</td>
                                </tr>
                                <tr>
                                    <td><i className="material-icons">home</i></td>
                                    <td>{this.renderAddress([user.StreetAddress1, user.StreetAddress2, user.City, user.State, user.PostalCode, user.Country])}</td>
                                </tr>
                                <tr>
                                    <td><i className="material-icons">cake</i></td>
                                    <td>{this.renderBirthday(user.Birthday)}</td>
                                </tr>
                                {
                                this.props.freshdeskID ?
                                <tr>
                                    <td><i className="material-icons">question_answer</i></td>
                                    <td><a target="_blank" href={`https://heidisawyer.freshdesk.com/a/contacts/${this.props.freshdeskID}`}>Freshdesk link</a></td>
                                </tr>
                                : null
                                }
                            </tbody>
                        </table>
                    </div>
            </div>
        );
    }
}

DashboardProfile.propTypes = {
    user: PropTypes.object.isRequired,
    freshdeskID: PropTypes.string
}

export default DashboardProfile;


/** WEBPACK FOOTER **
 ** ./src/components/DashboardProfile.js
 **/